import React, { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import InputWrapper from '../../../lib/components/Forms/InputWrapper'
import FormSelect from '../../../lib/components/Forms/FormSelect'
import { orderedCountries } from '../../../lib/constants'

const BasicForm = ({ checkoutStore }) => {
  const countryOptions = useMemo(
    () =>
      orderedCountries().map(([value, label]) => ({
        value,
        label,
      })),
    []
  )

  const handleChangeFirstName = (val) => checkoutStore.changeFirstName(val)
  const handleChangeLastName = (val) => checkoutStore.changeLastName(val)
  const handleChangeAddressLine = (val) => checkoutStore.changeAddressLine(val)
  const handleChangeAddressLine2 = (val) => checkoutStore.changeAddressLine2(val)
  const handleChangeCity = (val) => checkoutStore.changeCity(val)
  const handleChangeState = (val) => checkoutStore.changeState(val)
  const handleChangeZipCode = (val) => checkoutStore.changeZipCode(val)
  const handleChangeCountry = (val) => checkoutStore.changeCountry(val.value)
  const handleChangePhone = (val) => checkoutStore.changePhone(val)
  const handleChangeEmail = (val) => checkoutStore.changeEmail(val.trim())

  const {
    firstName,
    lastName,
    addressLine,
    addressLine2,
    city,
    state,
    zipCode,
    country,
    phone,
    email,
  } = checkoutStore

  useEffect(() => {
    handleChangeCountry(countryOptions[0])
  }, [])

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <InputWrapper label="First Name*" inputStore={firstName} onChange={handleChangeFirstName} />
      <InputWrapper label="Last Name*" inputStore={lastName} onChange={handleChangeLastName} />
      <InputWrapper
        onChange={handleChangeAddressLine}
        inputStore={addressLine}
        label="Address line 1*"
      />
      <InputWrapper
        onChange={handleChangeAddressLine2}
        inputStore={addressLine2}
        label="Address line 2"
      />
      <InputWrapper label="City*" inputStore={city} onChange={handleChangeCity} />
      <InputWrapper label="State*" inputStore={state} onChange={handleChangeState} />
      <InputWrapper
        label="Zip*"
        inputStore={zipCode}
        onChange={handleChangeZipCode}
        maxlength="15"
      />
      <InputWrapper
        value={countryOptions.filter((option) => country.value === option.value)[0] || null}
        onChange={handleChangeCountry}
        error={country.errorMessage}
        options={countryOptions}
        label="Country*"
        as={FormSelect}
      />
      <InputWrapper
        label="Cell phone number*"
        inputStore={phone}
        onChange={handleChangePhone}
        maxlength="20"
      />
      <InputWrapper label="Email*" inputStore={email} onChange={handleChangeEmail} email />
    </div>
  )
}

export default observer(BasicForm)
